import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'

@Component({
	components: {
		Loader,
	},
})
export default class CreateEventModal extends Vue {
	loading = false
	form = {
		start: '',
		end: '',
		url: '',
	}

	clearForm() {
		this.form.start = ''
		this.form.end = ''
		this.form.url = ''
	}

	async submit() {
		if (!this.form.start || !this.form.end || !this.form.url) {
			this.$bvToast.toast('Por favor, preencha todos os campos.', {
				title: 'Campos Obrigatórios',
				variant: 'warning',
				solid: true,
			})
			return
		}

		this.loading = true
		const res = await api.post('/api/notice-board/events', {
			...this.form,
		})
		console.log('res post: ', res)
		this.$bvModal.hide('modal-form-event')
		this.loading = false
	}
}
